import { createContext } from 'react';
import { IItemForGetShortInfo, IGamePositionItem } from 'types';

export type TChangeGamePositionSelectedItem = Nullable<string>;
export type TTypeOfChangeGamePositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeGamePositionState {
	IDSelectedCustomer: TChangeGamePositionSelectedItem;
	IDSelectedRestaurant: TChangeGamePositionSelectedItem;
	positionsData: IGamePositionItem[];
	typeOfModalWindow: TTypeOfChangeGamePositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
}

export const changeGamePositionInitialState: IChangeGamePositionState = {
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	fetchedRestaurants: [],
};

export interface IChangeGamePositionContext extends IChangeGamePositionState {
	setIDCustomer(value: TChangeGamePositionSelectedItem): void;
	setIDRestaurant(value: TChangeGamePositionSelectedItem): void;
	resetSelectedControls(): void;
	setPositionsData(data: IGamePositionItem[]): void;
	reorderItems(value: IGamePositionItem[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeGamePositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: string[]): void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

export const ChangeGamePositionContext = createContext<IChangeGamePositionContext>({
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	setFetchedRestaurants: () => undefined,
	...changeGamePositionInitialState,
});
